import React, { useState } from 'react';
import Select from 'react-select';
import { Table } from "antd";

const MainTab = () => {

    const columns = [
        { title: "Disch. Port", dataIndex: "SNo", key: "SNo" },
        { title: "ETA", dataIndex: "action", key: "action" },
        { title: "Tranship", dataIndex: "TrackingURL", key: "TrackingURL" },
    ];

    const dataSource = [
        {
            key: "", // Add a unique key for each row
            SNo: "", // Changed to camelCase
           
        },
    ]

    return (
        <>
            <div className="row border-bottom-2 card m-1">
                <div className="col-md-12 card-body">
                 <div className="row">
                            </div>
                            <div className="table-responsive custom-table mt-2">
                                <Table className="table datanew dataTable no-footer" pagination={false}
                                    dataSource={dataSource} columns={columns} />
                            </div>
                    
                <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                    <button className="btn btn-primary text-xs" type="button">
                        New
                    </button>
                    <button className="btn btn-primary text-xs" type="button">
                        Update
                    </button>
                    <button className="btn btn-primary text-xs" type="button">
                        Delete
                    </button>
                </div>
                </div>
            </div>

        </>
    );
};

export default MainTab
